<template>
  <div class="cost-container">
    <!--    操作 菜单-->
    <el-row style="margin: 10px">

      <el-col :span="4">
        <el-date-picker
            v-model="pageQuery.chooseDate"
            type="month"
            placeholder="选择年月"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="2">
        <el-button @click="fetchCostList">查询费用分摊</el-button>
      </el-col>
      <el-col :span="2">
        <el-button type="success" @click="importExcelDialog=true" class="ml-2">导入额外费用</el-button>
      </el-col>

      <el-col :span="2">
        <el-button v-permission="['workPhoneCost:export']" type="info" @click="handleExportCost">导出费用分摊</el-button>
      </el-col>
    </el-row>
<!--    <el-row>
      <el-col :span="2">
        <el-switch
            v-model="pageQuery.forceReload"
            size="large"
            active-text="重算"
            inactive-text="不变"
            active-value="2"
            inactive-value="1"
        />
      </el-col>
      <el-col :span="2">
        <el-button type="primary" @click="computeMonthCost" :disabled="!pageQuery.chooseDate">计算费用分摊</el-button>
      </el-col>
    </el-row>-->

    <!--统计展示项-->
    <el-row :gutter="20" style="margin: 0 auto;">
      <el-col :span="2" v-for="(item, index) in showCountData" :key="index">
        <div style="border: 1px solid;border-radius: 10px;padding: 10px;margin: 10px"
        >
          <el-statistic
              :precision="0"
              :value="item.value"
              :title="item.title"
          ></el-statistic>
        </div>
      </el-col>

    </el-row>
    <!--列表展示-->
    <el-table :data="costList" border stripe>
      <el-table-column label="年份" prop="costYear" align="center"/>
      <el-table-column label="月份" prop="costMonth" align="center"/>
      <el-table-column label="手机号" prop="phoneNumber" align="center"/>
      <el-table-column label="使用人（教练）" prop="useCoachName" align="center"/>
      <el-table-column label="号卡费用" prop="riseMoney" align="center"/>
      <el-table-column label="操作" align="center" width="340">
        <template #default="scope">
          <el-button size="small" type="primary" @click="handleEditPhoneCost(scope.row)">修改</el-button>
          <!--<el-button size="small" type="primary" @click="handleEditPhoneCost(scope.row)">修改</el-button>
          <el-button size="small" type="text" @click="handleEditPhoneCost(scope.row)">操作记录</el-button>-->
        </template>
      </el-table-column>
    </el-table>

    <!--    分页-->
    <div style="display: flex;justify-content: end;margin-top: 20px">
      <el-pagination
          v-model:current-page="pageQuery.pageIndex"
          v-model:page-size="pageQuery.pageSize"
          :page-sizes="[20, 50, 100, 150, 200, 250, 300]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
          @size-change="fetchCostList"
          @current-change="fetchCostList"
      />
    </div>


    <!-- 新增/修改弹窗 -->
    <el-dialog title="号卡费用修改" v-model="dialogEditCostVisible" width="500px">
      <el-form :model="costForm" :rules="costFormRules" ref="costFormRef" label-width="120px">
        <el-form-item label="手机号" prop="phoneNumber">
          <el-input v-model="costForm.phoneNumber" placeholder="请输入手机号" :disabled="isEditCost"/>
        </el-form-item>
        <el-form-item label="年-月">
          {{ costForm.costYear }}-{{ costForm.costMonth }}
        </el-form-item>
        <el-form-item label="教练">
          {{ costForm.useCoachName }}
        </el-form-item>

        <el-form-item label="套餐费" prop="originMoney">
          <el-input v-model="costForm.originMoney" placeholder="请输入套餐费" type="number" step="0.01"/>
        </el-form-item>
        <el-form-item label="功能费" prop="riseMoney">
          <el-input v-model="costForm.riseMoney" placeholder="请输入副卡功能费" type="number" step="0.01"/>
        </el-form-item>

        <el-form-item label="修改备注" prop="remarkNote" v-if="isEditCost">
          <el-input v-model="costForm.remarkNote" placeholder="请填写修改原因/备注"/>
        </el-form-item>
      </el-form>
      <div>
        <el-button @click="dialogEditCostVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </div>
    </el-dialog>
  </div>

  <!--  导入费用-弹框-->
  <el-dialog title="导入费用"
             v-model="importExcelDialog"
             width="500px"
             :append-to-body="true"
             :draggable="true"
  >
    <div style="display: flex; justify-content: center">
      <el-upload
          action="#"
          :auto-upload="false"
          :on-change="handleExcelChange"
          accept=".xlsx, .xls"
          class="upload-demo"
      >
        <el-button type="primary">选择额外费用Excel</el-button>
      </el-upload>
    </div>
    <div style="margin:30px 0 0 20px">
      <!--      <a href="https://minio.yanhuotiyu.com/yhoss/web/%E5%AF%BC%E5%85%A5%E5%B7%A5%E4%BD%9C%E5%8F%B7.xlsx">-->
      <a href="https://minio.yanhuotiyu.com/yhoss/web/%E5%AF%BC%E5%85%A5%E6%89%BF%E6%8B%85%E4%B8%8E%E9%A2%9D%E5%A4%96%E8%B4%B9%E7%94%A8.xlsx">
        <el-link type="danger">下载导入额外费用模板！</el-link>
      </a>
    </div>

    <div style="display: flex; justify-content: center; padding-top: 30px">
      <el-button type="success" @click="handleImportCost" class="ml-2">确认导入</el-button>
    </div>
  </el-dialog>
</template>

<script>
import XLSX from 'xlsx'
import {computePhoneCost, editPhoneCost, exportCostExcel, fetchCostList, importCostDivide} from "@/api/workphone";

export default {
  name: 'WorkPhoneCost',
  data() {
    return {
      costList: [],//费用列表数据
      excelFile: null,//所选excel 文件
      // tabActiveName: 'first',//所选tabs
      importExcelDialog: false,//导入费用弹框
      showCountData: [],//统计费用相关项
      pageQuery: {
        phoneNumber: null,
        chooseDate: '',
        pageIndex: 1,
        pageSize: 100,
        forceReload: 1,//是否强制重新计算 该月的费用
      },//查询入参
      pageTotal: 0,//分页数据总条数
      costForm: {
        costYear: null,
        costMonth: null,
        phoneNumber: null,
        useCoachName: null,
        originMoney: null,
        riseMoney: null,
        remarkNote: null,
      },//编辑费用的行表单
      isEditCost: false,//是否是 修改时 而不是新增时
      dialogEditCostVisible: false,//编辑弹框是否显示
      costFormRules: {
        phoneNumber: [{required: true, message: '请输入手机号', trigger: 'blur'}],
        originMoney: [{required: true, message: '请输入套餐金额', trigger: 'blur'}],
      },//表单验证规则
    }
  },
  mounted() {
    this.fetchCostList()
  },
  methods: {

    // 修改工作号
    handleEditPhoneCost(row) {
      this.isEditCost = true
      this.costForm = {...row}
      this.dialogEditCostVisible = true
    },

    //tabs选项卡点击
    handleClick(tab, event) {
      console.log(tab, event)
    },
    //计算所选月份 分摊
    computeMonthCost() {
      //计算所选月份的费用分摊,返回当月的 费用承担表
      computePhoneCost(this.pageQuery).then(res => {
        console.log(res);
        if (res.code === 200) {
          this.costList = res.data.records
          this.pageTotal = res.data.total
        }
      }).catch(err => {
        this.$message.error(err.message || '获取数据失败')
      })
    },

    // 获取费用分摊列表
    fetchCostList() {
      //计算所选月份的费用分摊,返回当月的 费用承担表
      fetchCostList(this.pageQuery).then(res => {
        console.log(res);
        if (res.code === 200) {
          this.costList = res.data.records
          this.pageTotal = res.data.total
        }
      }).catch(err => {
        this.$message.error(err.message || '获取数据失败')
      })
    },

    // 选择Excel文件
    handleExcelChange(file) {
      this.excelFile = file.raw
    },

    // 导入费用分摊数据
    handleImportCost() {
      if (!this.excelFile) {
        this.$message.warning('请先选择Excel文件')
        return
      }

      const reader = new FileReader()
      reader.onload = (e) => {
        try {
          console.log(e);
          const data = new Uint8Array(e.target.result)
          const workbook = XLSX.read(data, {type: 'array'})
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]
          const excelData = XLSX.utils.sheet_to_json(worksheet)

          console.log(excelData);
          // 这里可以添加数据校验逻辑

          const formData = new FormData()
          formData.append('file', this.excelFile)
          //执行导入
          importCostDivide(formData).then((value) => {
            console.log(value);
            this.hintMessage = "开始导入";
            this.fileList = [];
            if (value.code === 200) {
              this.$message.success("导入成功");
            } else {
              this.$message.warning("导入失败,");
            }
          });
        } catch (error) {
          this.$message.error('解析Excel文件失败')
          console.error(error)
        }
      }
      reader.readAsArrayBuffer(this.excelFile)
    },

    // 导出费用分摊数据
    handleExportCost() {
      exportCostExcel(this.pageQuery)
      this.$message.success("导出执行完成,请在右上角下载管理查看进度");
    },
    //号卡费用分摊 修改
    handleSubmit() {
      this.$refs.costFormRef.validate(valid => {
        if (valid) {
          if (this.isEditCost) {
            //修改
            editPhoneCost(this.costForm).then(res => {
              if (res.code === 200) {
                this.$message.success('修改成功')
                this.dialogEditCostVisible = false
                this.fetchCostList()
              }
            }).catch(err => {
              this.$message.error(err.message || '修改失败')
            })
          }
        }
      })
    },
  }
}
</script>

<style scoped>
.cost-container {
  padding: 20px;
}
</style>
